import { render, staticRenderFns } from "./Bitacora.vue?vue&type=template&id=8dd7f6b0"
import script from "./Bitacora.vue?vue&type=script&lang=js"
export * from "./Bitacora.vue?vue&type=script&lang=js"
import style0 from "./Bitacora.vue?vue&type=style&index=0&id=8dd7f6b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports